import ConsultationFluxTab from "@features/stock/components/ConsultationFluxTab";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/consultation/")({
  component: ConsultationFluxTab,
});
